import { Organisation } from "../models/organisation";
import axiosConfig from "./axiosConfig";

const getOrganisation = async (
  authToken: string,
  orgId: string,
  userOrgId?: string
): Promise<Organisation> => {
  const { data } = await axiosConfig.get(
    `/organisation/${orgId}${userOrgId ? `?userOrgId=${userOrgId}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getOrganisation;
